import { storageModeInfo } from './getAdapter';
import { getProductModeInfo } from './productMode';
import { isDesktopRuntime } from './rustCalculationEngine';
import { sampleDataApi } from './sampleData';
import { loadOne, now, saveOne } from './storage';

const DEMO_SAMPLE_SEED_KEY = 'demo_sample_seed';
const DEMO_SAMPLE_SEED_VERSION = 1;

interface DemoSampleSeedMarker {
  version: number;
  seeded_at: string;
}

function autoSeedEnabled(): boolean {
  return import.meta.env.VITE_DEMO_AUTO_SEED !== 'false';
}

export async function seedWebDemoSampleData(): Promise<boolean> {
  if (!autoSeedEnabled()) return false;
  if (isDesktopRuntime()) return false;
  if (storageModeInfo.mode !== 'demo-local') return false;
  if (getProductModeInfo().mode !== 'demo') return false;

  const marker = loadOne<DemoSampleSeedMarker>(DEMO_SAMPLE_SEED_KEY);
  if (marker?.version === DEMO_SAMPLE_SEED_VERSION) return false;

  await sampleDataApi.seedScenario();
  saveOne<DemoSampleSeedMarker>(DEMO_SAMPLE_SEED_KEY, {
    version: DEMO_SAMPLE_SEED_VERSION,
    seeded_at: now(),
  });
  return true;
}
